import React, { useEffect } from 'react';

/**
 * Annual/decennial: state is green (already in current month). Confirm before removing from this month.
 */
const CurrentMonthRemoveModal = ({ isOpen, stateLabel, currentMonthYear, onClose, onConfirm }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const monthReadable = currentMonthYear ? currentMonthYear.replace('-', ' ') : currentMonthYear;

  return (
    <div
      className="current-month-remove-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="current-month-remove-title"
      onClick={onClose}
    >
      <div className="current-month-remove-modal" onClick={(e) => e.stopPropagation()}>
        <div className="current-month-remove-modal__accent" aria-hidden="true" />
        <div className="current-month-remove-modal__inner">
          <h2 id="current-month-remove-title" className="current-month-remove-modal__title">
            Remove this sighting?
          </h2>
          <p className="current-month-remove-modal__body">
            {stateLabel ? (
              <>
                Remove <strong className="current-month-remove-modal__state">{stateLabel}</strong> for{' '}
              </>
            ) : (
              <>Remove this plate for </>
            )}
            <strong>{monthReadable}</strong>? Past months you logged this plate stay the same.
          </p>
          <div className="current-month-remove-modal__actions">
            <button type="button" className="current-month-remove-modal__ghost" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="current-month-remove-modal__danger" onClick={onConfirm}>
              Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentMonthRemoveModal;
